<template>
  <div id="app" class="container bg-lightblur bg-transparent-darkmode" :class="{ 'flex-column': !tokenExists() }">
    <!-- Main body content -->
    <template
      v-if="
        tokenExists() &&
        $route.name != 'Booking List' &&
        $route.name != 'Onboard' &&
        $route.name != 'Booking' &&
        $route.name != 'Video embed' &&
        $route.name != 'Request Calendar' &&
        $route.name != 'Connect Client' &&
        $route.name != 'Invite'
      ">
      <!-- Topnav -->
      <Topnav :class="{ hide: $route.query.type == 'embed' }" @openShare="open_share = true" />

      <!-- Upgrade bar -->
      <template v-if="me && me.plan_type == 'entry_trial'">
        <div v-if="blackfriday" class="blackfriday-bar pointer" @click="$root.$emit('toggle-upgrade', true)">
          <img src="@/assets/img/blackfriday.png" alt="BLACKFRIDAY" />
        </div>
        <div v-else class="bg-white upgrade-bar animated fadeIn faster hide-xs">
          <h6 class="mb-0">You are on Weezly trial. Please upgrade your account now.</h6>
          <div class="flex-1"></div>
          <button class="btn btn-warning" @click="$root.$emit('toggle-upgrade', true)">Upgrade!</button>
        </div>
      </template>

      <!-- First loading -->
      <div v-if="first_loading" class="flex-1 items-center flex">
        <Loading />
      </div>

      <!-- Main App -->
      <template v-else>
        <router-view ref="router" :key="routerKey" />
        <Share v-if="open_share" @close="open_share = false" />
        <Milestone />
      </template>

      <!-- Upgrade Page -->
      <div class="upgrade-view" v-if="open_upgrade" :class="animation_upgrade">
        <Upgrade />
      </div>

      <!-- Upgrade Wall -->
      <UpgradeWall />
    </template>
    <component v-else-if="$route.meta.component" :is="$route.meta.component" />
    <router-view v-else ref="router" :key="routerKey" />
    <Alert />
    <div id="hideTooltip" class="hide"></div>
  </div>
</template>
<style lang="css">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap");
</style>
<style lang="css">
@import "./assets/lib/line-awesome/css/line-awesome.min.css";
</style>
<style lang="css">
@import "./assets/css/style.css";
</style>

<script>
import "@/assets/css/embed/animate.min.css";
import request from "@/service/index";
import Share from "@/components/Scheduling/Share/Share";
import Upgrade from "@/views/Upgrade";
import { getBrowserLocale, languages } from "@/constants/scheduling";
import axios from "axios";
import moment from "moment-timezone";
import UpgradeWall from "@/components/UpgradeWall";
import Milestone from "@/components/Milestone/Milestone";
import { is_internal_weezly } from "@/helpers/functions";

export default {
  name: "App",
  components: {
    Share,
    Upgrade,
    UpgradeWall,
    Milestone,
  },
  data: function () {
    return {
      routerKey: 0,
      first_loading: true,
      open_share: false,
      open_upgrade: false,
      animation_upgrade: "",

      interval: false,
      isMobile: false,

      blackfriday: false,
    };
  },
  created() {},
  beforeDestroy() {
    clearInterval(this.interval);
  },
  async beforeMount() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) | (window.innerWidth < 768)) {
      this.isMobile = true;
    }

    let language = window.localStorage.getItem("language");
    if (language) {
      this.$i18n.locale = language;
      moment.locale(language);
    } else {
      let lg = "";

      const ipInfo = await axios({
        method: "get",
        url: "http://ip-api.com/json",
      }).catch((e) => {});

      if (ipInfo) {
        let guess_language = ipInfo.data.countryCode.toLowerCase();
        let the_language = languages.find((l) => l.flag == guess_language);
        if (the_language) lg = the_language.key;
      }

      if (lg == "") {
        let guess_language = getBrowserLocale();
        let the_language = languages.find((l) => l.key == guess_language);
        if (the_language) lg = the_language.key;
      }

      if (lg == "") lg = "en";

      this.$i18n.locale = lg;
      moment.locale(lg);
      window.localStorage.setItem("language", lg);
    }

    let theme = window.localStorage.getItem("theme");
    if (!["/externaltimeslot", "/external-dynamic", "/external-dynamic-campaign"].includes(location.pathname)) {
      if (!theme | (theme == "dark")) {
        document.body.setAttribute("data-theme", "dark");
        window.localStorage.setItem("theme", "dark");
      }
    } else {
      document.body.classList.add("loading");
    }
  },
  async mounted() {
    this.$root.$on("refreshRouter", () => {
      this.routerKey++;
    });

    this.$root.$on("first_loading", (value) => {
      this.first_loading = value;
    });

    this.$root.$on("toggle-upgrade", (value) => {
      if (value == true) {
        if (!is_internal_weezly) {
          location.href = "https://app.weezly.com/upgrade";
          return false;
        }
        this.animation_upgrade = "animated faster zoomIn";
        this.open_upgrade = true;
        setTimeout(() => {
          this.animation_upgrade = "";
        }, 500);
      } else {
        this.animation_upgrade = "animated faster zoomOut";
        setTimeout(() => {
          this.animation_upgrade = "";
          this.open_upgrade = false;
        }, 500);
      }
    });

    this.$root.$on("blackfriday", (blackfriday) => {
      this.blackfriday = blackfriday;
    });

    // Background image
    // let img = document.getElementById("bgimage");
    // if (img) img.src = this.domain + "/external/imgs/bg-colorful.png";
    // this.interval = setInterval(() => {
    //   this.spotlight();
    // }, 10000);
  },
  watch: {},
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
  },
  methods: {
    tokenExists() {
      if (window.localStorage.token) return true;
      return false;
    },
    spotlight() {
      var h_body = document.body.clientHeight;
      var w_body = document.body.clientWidth / 2;

      // var s_x = 1570;
      // var s_y = 1070;

      var s_x = 2178;
      var s_y = 876;

      let x = this.rnd(0, w_body);
      let y = this.rnd(0, h_body);

      x = s_x - x;
      y = s_y - y;

      x = -1 * x;
      y = -1 * y;

      x = x + w_body;

      // let img = document.getElementById("bgimage");
      // if (img) {
      //   img.style.left = x + "px";
      //   img.style.top = y + "px";
      // }
      document.body.style.backgroundPositionX = x + "px";
      document.body.style.backgroundPositionY = y + "px";
    },
    rnd(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
  },
};
</script>

<style>
.grecaptcha-badge {
  visibility: hidden;
}
</style>
